export const POST_CARD_TYPES = {
  HORIZONTAL_WITH_LEFT_THUMBNAIL:
    "horizontal-with-left-thumbnail",
  HORIZONTAL_WITH_RIGHT_THUMBNAIL:
    "horizontal-with-right-thumbnail",
};

export const CARD_ORIENTATION = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
};

export const IMG_POSITION = {
  LEFT: "left",
  RIGHT: "right",
};

export const FALLBACK_IMG =
  "https://static.share.market/images/blog/2056/1160/fallback_all_articles.png";

export const FALLBACK_IMG_ALT = "Buzz Article";

export const POST_CARD_DATA = {
  TITLE: "t3",
  CATEGORY: "t4",
  URL: "t5",
  PUBLISH_DATE: "t6",
};
